var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 26,
    viewBox: "0 0 48 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 26,
    rx: 13,
    fill: "url(#paint0_linear_1569_48365)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.848 17.132C17.416 17.132 18.88 15.608 18.88 13.316V12.404H15.028V13.82H16.96C16.924 14.804 16.336 15.632 14.896 15.632C13.216 15.632 12.508 14.444 12.508 12.788V12.692C12.508 10.94 13.384 9.824 14.872 9.824C15.904 9.824 16.564 10.28 16.732 11.288H18.664C18.46 9.164 16.756 8.288 14.848 8.288C12.316 8.288 10.48 10.088 10.48 12.668V12.764C10.48 15.308 12.04 17.132 14.848 17.132ZM23.0593 15.812C22.0753 15.812 21.5233 15.092 21.5233 13.892V13.796C21.5233 12.596 22.0993 11.9 23.0593 11.9C24.0313 11.9 24.5953 12.62 24.5953 13.82V13.904C24.5953 15.092 24.0313 15.812 23.0593 15.812ZM23.0473 17.132C24.9313 17.132 26.3593 15.872 26.3593 13.892V13.796C26.3593 11.84 24.9433 10.58 23.0593 10.58C21.1753 10.58 19.7473 11.864 19.7473 13.832V13.928C19.7473 15.884 21.1753 17.132 23.0473 17.132ZM27.5738 17H29.3018V7.88H27.5738V17ZM33.2411 17.132C34.1651 17.132 34.9331 16.592 35.2571 15.956V17H36.9851V7.88H35.2571V11.66C34.9091 11.024 34.2851 10.58 33.2771 10.58C31.7051 10.58 30.5171 11.792 30.5171 13.856V13.952C30.5171 16.04 31.7171 17.132 33.2411 17.132ZM33.7571 15.776C32.8931 15.776 32.2931 15.164 32.2931 13.916V13.82C32.2931 12.572 32.8331 11.912 33.8051 11.912C34.7531 11.912 35.3051 12.548 35.3051 13.796V13.892C35.3051 15.164 34.6691 15.776 33.7571 15.776Z",
    fill: "#0B0B0C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1569_48365",
    x1: 0,
    y1: 0,
    x2: 50.8356,
    y2: 18.9246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE8625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400005,
    stopColor: "#F7EF8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76629,
    stopColor: "#D2AC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDC967"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.f42da02f522f82487597fbe12ca3d49a.svg";
export { ForwardRef as ReactComponent };